import React from "react";
import { Icon, IconButton } from "@material-ui/core";

import { getStaticUrl } from "js/config";
import { FlexLayout } from "js/Components/FlexLayout";
import { TextContent } from "js/Components/TextContent";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import ImportFileDialog from "js/react/views/ImportFile/ImportFileDialog";
import { FileType } from "js/core/utilities/fileSourcesAndTypes";

export default function FileContextInput(props: {
    file: File | null;
    onFileChange: (file: File | null) => void;
}) {
    const { file, onFileChange } = props;

    const openFilePicker = () => {
        ShowDialog(ImportFileDialog, {
            fileTypes: [FileType.Document],
            closeOnSuccess: true,
            onSuccess: (selectedFile: File) => {
                onFileChange(selectedFile);
            }
        });
    };

    return (
        <FlexLayout border="1px solid #EEE" height={38} padding="7px 6px 7px 12px" gap={10}>
            <img src={getStaticUrl("/images/text-snippet.svg")} />
            <FlexLayout noHover width="fill" clickable onClick={openFilePicker}>
                <TextContent> {file ? file.name : "Upload a document..."}</TextContent>
            </FlexLayout>
            <IconButton size="small" onClick={() => onFileChange(null)}>
                <Icon fontSize="small">close</Icon>
            </IconButton>
        </FlexLayout>
    );
}

